import { Component, OnInit, ViewChild } from '@angular/core';
import { Tab } from '../ngx-query-editor.models';
import { FormControl } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material';

@Component({
  selector: 'lib-query-area',
  templateUrl: './query-area.component.html',
  styleUrls: ['./query-area.component.scss']
})
export class QueryAreaComponent implements OnInit {

  @ViewChild('editor') editor: any;

  editorOptions = { theme: 'vs-light', language: 'sql' };
  public code: string;

  tabs: Tab[] = [];
  tabNames: string[] = [];
  selected = new FormControl(0);
  selectedDbName: string;
  emptyState: boolean;

  ngOnInit() {
  }

  addTab(dbName: string) {
    // This is just a workaround to delay the function call if monaco editor is not loaded
    // TODO: change this to a clean implementation http://192.168.0.78/ikhalsi/ng-db-query-editor/issues/32
    try {
        this.addTabToMonacoEditor(dbName);
    } catch (error) {
      setTimeout(() => this.addTabToMonacoEditor(dbName), 1000);
    }
  }

  setEmptyState(state: boolean) {
    this.emptyState = state;
  }

  private addTabToMonacoEditor(dbName: string) {
    const model = monaco.editor.createModel(' -- Using ' + dbName + '\n', 'sql');
    this.editor._editor.setModel(model);
    this.tabs.push({
      tabDatabase: dbName,
      tabEditorModel: model,
      tabModelUri: model.uri
    });
    this.selected.setValue(this.tabs.length - 1);
    this.tabNames.push('new query-' + dbName);
    this.selectedDbName = dbName;
  }

  onChangeTab(event: MatTabChangeEvent) {
    this.changeTab(event.index);
  }

  onCloseTab(index: number) {
    this.changeTab(index + 1);
    this.tabNames.splice(index, 1);
    this.tabs.splice(index, 1);
  }

  private changeTab(index: number) {
    if (index === this.tabs.length) {
      this.editor._editor.setModel(this.tabs[index - 1].tabEditorModel);
      this.selectedDbName = this.tabs[index - 1].tabDatabase;
      this.code = monaco.editor.getModel(this.tabs[index - 1].tabModelUri).getValue();
    } else {
      this.editor._editor.setModel(this.tabs[index].tabEditorModel);
      this.selectedDbName = this.tabs[index].tabDatabase;
      this.code = monaco.editor.getModel(this.tabs[index].tabModelUri).getValue();
    }
  }

  public getCode() {
    return this.code;
  }

}
